import React, { useLayoutEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import FundsCardCharts from "../components/FundsCardCharts";
import FundsCard from "../components/FundsCard";

function Chart(props) {
  const { id, data = [], total = 0, totalLabel = "", title = "", variant, spaces, columns, count, cardArrayData = [], from, indexKey } = props;
  const screenWidth = window.innerWidth;
  const isTabletLarge = screenWidth >= 992 && screenWidth <= 1199;
  
  const isSmallScreen = screenWidth <= 1440;
  const scaleFontSize = (size) => (isSmallScreen ? Math.round(size * 0.7) : size);

  useLayoutEffect(() => {
    

    if (variant === "insurances") {
      // const root = am5.Root.new(id);
      const root = am5.Root.new(id, {
        useSafeResolution: false
      });
      root._logo?.dispose();
      root.setThemes([am5themes_Animated.new(root)]);

      const chart = root.container.children.push(
        am5percent.PieChart.new(root, {
          y: isTabletLarge ? am5.percent(5) : "",
          innerRadius: am5.percent(65),
          radius: isTabletLarge ? am5.percent(100) : am5.percent(80),
        })
      );

      const series = chart.series.push(
        am5percent.PieSeries.new(root, {
          valueField: "value",
          categoryField: "category",
          alignLabels: true,
        })
      );

      {console.log("total of the chart",total)}
      chart.children.unshift(
        am5.Label.new(root, {
          text: total === 0 ? "ללא נתונים" : `₪${Math.floor(total || 0).toLocaleString("he-IL")}`,
          fontSize: scaleFontSize(isTabletLarge ? 20 : 24),
          fontWeight: "bold",
          fill: am5.color("#0F0E0E"),
          textAlign: "center",
          textVerticalAlign: "middle",
          centerX: am5.p50,
          centerY: am5.p50,
          x: am5.p50,
          y: am5.p50,
        })
      );
        {console.log("total of the chart",total)}
      chart.children.unshift(
        am5.Label.new(root, {
          text: title,
          fontSize: scaleFontSize(isTabletLarge ? 20 : 24),
          fontWeight: "bold",
          fill: am5.color("#0F0E0E"),
          textAlign: "right",
          x: am5.p100,
          y: isTabletLarge ? am5.percent(-8) : "",
        })
      );

      series.labels.template.setAll({
        forceHidden: true,
      });

      series.ticks.template.adapters.add("visible", () => false);

      series.slices.template.setAll({
        strokeWidth: 4,
        stroke: am5.color(0xffffff),
        tooltipText: "{category}: ₪{value}",
      });

      series.slices.template.set("tooltip", am5.Tooltip.new(root, {}));

      series.slices.template.get("tooltip")?.label.setAll({
        textAlign: "center",
      });

      series.data.setAll(data);

      series.slices.each((slice, index) => {
        const settings = data[index]?.settings;
        slice.setAll({
          fill: settings?.fill,
        });
      });

      return () => {
        root.dispose();
      };
    }
    if (variant === "calculation") {
      // const root = am5.Root.new(id);
      const root = am5.Root.new(id, {
        useSafeResolution: false
      });
      root._logo.dispose();
      root.setThemes([am5themes_Animated.new(root)]);

      const chart = root.container.children.push(
        am5percent.PieChart.new(root, {
          startAngle: 320,
          endAngle: 138,
          innerRadius: am5.percent(80),
        })
      );
      
      const series = chart.series.push(
        am5percent.PieSeries.new(root, {
          y: am5.percent(20),
          startAngle: 380,
          endAngle: 160,
          valueField: "value",
          categoryField: "category",
          alignLabels: true,
        })
      );

      function getFontSize() {
        return window.innerWidth < 768 ? 22 : 36; 
      }

      chart.children.unshift(
        am5.Label.new(root, {
          text: `₪${Math.floor(total || 0).toLocaleString("he-IL")}`,
          fontSize: getFontSize(),
          fontWeight: "bold",
          fill: am5.color("#0F0E0E"),
          textAlign: "center",
          textVerticalAlign: "middle",
          centerX: am5.p50,
          x: am5.p50,
          y:  am5.percent(65),
        })
      );
      chart.children.unshift(
        am5.Label.new(root, {
          text: totalLabel,
          fontSize: 18,
          fontWeight: "bold",
          fill: am5.color("#333333"),
          textAlign: "center",
          textVerticalAlign: "middle",
          centerX: am5.p50,
          x: am5.p50,
          y:  am5.percent(50),
        })
      );
      series.labels.template.setAll({
        forceHidden: true,
      });

      series.ticks.template.adapters.add("visible", () => false);

      series.slices.template.setAll({
        strokeWidth: 4,
        stroke: am5.color(0xffffff),
        tooltipText: "{category}: ₪{value}",
        cornerRadius: 5
      });
      series.slices.template.set("tooltip", am5.Tooltip.new(root, {}));

      series.slices.template.get("tooltip").label.setAll({
        textAlign: "center",
      });
      
      series.data.setAll(data);

      series.slices.each((slice, index) => {
        const settings = data[index].settings;
        slice.setAll({
          fill: settings.fill,
        });
      });

      return () => {
        root.dispose();
      };
    }
    if (variant === "horizontal") {
      // const root = am5.Root.new(id);
      const root = am5.Root.new(id, {
        useSafeResolution: false
      });
      root._logo?.dispose();
      root.setThemes([am5themes_Animated.new(root)]);

      const chart = root.container.children.push(
        am5percent.PieChart.new(root, {
          y: isTabletLarge ? am5.percent(5) : "",
          innerRadius: am5.percent(65),
          radius: isTabletLarge ? am5.percent(100) : am5.percent(80),
        })
      );

      const series = chart.series.push(
        am5percent.PieSeries.new(root, {
          valueField: "value",
          categoryField: "category",
          alignLabels: true,
        })
      );

      chart.children.unshift(
        am5.Label.new(root, {
          text: `₪${Math.floor(total).toLocaleString("he-IL")}`,
          fontSize: isTabletLarge ? 14 : 16,
          fontWeight: "bold",
          fill: am5.color("#0F0E0E"),
          textAlign: "center",
          textVerticalAlign: "middle",
          centerX: am5.p50,
          centerY: am5.p50,
          x: am5.p50,
          y: am5.percent(55),
        })
      );
      chart.children.unshift(
        am5.Label.new(root, {
          text: totalLabel,
          fontSize: 12,
          fontWeight: 400,
          fill: am5.color("#86909C"),
          textAlign: "center",
          textVerticalAlign: "middle",
          centerX: am5.p50,
          x: am5.p50,
          y: am5.percent(40),
        })
      );

      series.labels.template.setAll({
        forceHidden: true,
      });

      series.ticks.template.adapters.add("visible", () => false);

      series.slices.template.setAll({
        strokeWidth: `${spaces === 'noSpaces' ? 0 : 4}`,
        stroke: `${spaces === 'noSpaces' ? '' : am5.color(0xffffff)}`,
        tooltipText: "{category}: ₪{value}",
      });

      series.slices.template.set("tooltip", am5.Tooltip.new(root, {}));

      series.slices.template.get("tooltip")?.label.setAll({
        textAlign: "center",
      });

      series.data.setAll(data);

      series.slices.each((slice, index) => {
        const settings = data[index]?.settings;
        slice.setAll({
          fill: settings?.fill,
        });
      });

      return () => {
        root.dispose();
      };
    }
  }, [id, data, total, totalLabel, title, variant]);

  return (
    <div className="chart-list d-flex flex-column white-bg radius-20">
      <div className={spaces == "noSpaces" ? "chart chart-100" : 'chart'} id={id}></div>
      {spaces !== 'noSpaces' && (from === "summary" || from === "loan") && <FundsCardCharts count={count} cardArrayData={cardArrayData} from={from} indexKey={indexKey} />}
      {spaces !== 'noSpaces' && from !== "summary" && from !== "loan" && <FundsCard count={count} />}

      {data?.some(item => item?.category || item?.value) && (
        <div className={`category-main d-flex flex-wrap`}>
          {data?.map((item, index) => (
            <div className={columns == 3 ? "category-list category-list-33" : "category-list"} key={`${id}-${index}`}>
              <div className="list-inner">
                <div className="category" style={{"--category-color": item?.settings?.fill?.toCSS?.() || "", color: item?.settings?.fill?.toCSS?.() || "" }}>{item?.category || ""}</div>
                <div className="value">
                  ₪{Math.floor(parseFloat(item?.value || 0)).toLocaleString()}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Chart;
